export default "__VITE_ASSET__BvV6ribh__"